import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["faq"];

  faqAnswer(e) {
    this.faqTarget.classList.toggle("providers-faq-content-box__answer--show");
  }
}
